import { Injectable, OnInit } from "@angular/core";
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from "@angular/router";
import { Observable } from "rxjs";
import { MainService } from "../Services/service.service";

@Injectable({
    providedIn: "root"
})
export class Over18Guard implements CanActivate {
    constructor(private services: MainService) { }

    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        return new Promise<boolean>((rs, rj) => {
           
            this.services.disclaimerIsReady = false;
            if (this.services.Over18Years) {
                this.services.disclaimerIsReady = true;
                return rs(true);
            } else {
                this.services.over18Change.subscribe((value) => {
                    return rs(value);
                });

                if (next.url.length > 0) {
                    const oldUrl = next.url.map(u => u.path).join("/");
                    this.services.showEnterDialog(oldUrl);
                } else {
                    this.services.showEnterDialog("");
                }
            };
        });
    }
}
